import React from 'react';
import { Form, Input, Tooltip, Select, Row, Col, Button, Icon } from 'antd';
import {notification} from 'antd';
import history from '../../modules/History';
import { updatePageItem } from '../../modules/Api';

class PageForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitted: props.submitted ? props.submitted : false
        }
    }

    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        if(values.id){
            updatePageItem(values.slug, values, () => {
                notification.open({
                    message: `صفحه با موفقیت ویرایش شد!`,
                    description: ``
                });
                this.setState({submitted: false});
            })
        }
    }

    render() {
        const Handler = this.props.handler.component;
        const options = this.props.handler.options ? this.props.handler.options : {};
        return (
            <div style={{direction: 'rtl', padding: "20px"}}>
                <Handler options={options} initialData={this.props.initialData} submitted={false} submit={this.submit.bind(this)}/>
            </div>
        );
    }
}
export default PageForm;



// WEBPACK FOOTER //
// ./src/containers/Pages/form.js